export default __webpack_public_path__ + "static/media/maquina.0e362b44.png";